export const getReturnSalesChartSeries = (theme, metrics) => {
  return {
    bars: [
      { label: metrics.total.label, field: metrics.total.seriesField, color: theme.colors.text.link.default },
      { label: metrics.returned.label, field: metrics.returned.seriesField, color: theme.colors.background.decorative },
    ],
    line: {
      label: metrics.rate.label,
      field: metrics.rate.seriesField,
      color: theme.colors.outline.default,
      labelColor: theme.colors.outline.default,
    },
  }
}
